import { createSlice } from '@reduxjs/toolkit';

const modelArchiveSlice = createSlice({
  name: 'modelArchive',
  initialState: {
    models: {
      list: [],
      totalRecords: 0,
    },
  },
  reducers: {
    storeArchiveModels: (state, action) => {
      state.models = action.payload;
    },
  },
});

const {
  reducer: modelArchiveReducer,
  actions: { storeArchiveModels },
} = modelArchiveSlice;

export { modelArchiveReducer, storeArchiveModels };
